import React, { Component, Fragment } from 'react'
import styled from 'styled-components'

const DocLabel = styled.label`
  width: 80%;
  box-sizing: border-box;
  height: 140px;
  display: block;
  font-size: 16px;
  margin: 20px 0;
`

const DocInput = styled.input`
  opacity: 0;
  position:absolute;
  left:-9999px;
`

const Flex = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const DocDrop = styled.div`
  width: 100%;
  height: 100%;
  border: 2px dashed ${props => props.hovering ? '#3399CC' : '#979797'};
  box-sizing: border-box;
  background: ${props => props.hovering ? '#85CBEF' : '#F7F6F7'};
  color: ${props => props.hovering ? 'white' : 'inherit'};
  display: flex;
  &:hover {
    background: #85CBEF;
    border-color: #3399CC;
    color: white;
  };
  justify-content: center;
  align-items: center;
  border-radius: 5px;
`
const Icon = styled.i`
  border-radius: 50%;
  border: none;
  color: inherit;
  height: 30px;
  width: 30px;
  display: flex;
  line-height: 30px;
  justify-content: center;
  align-items: center;
  background: none;
  padding: 5px;
  margin-left: 4px;
  margin-right: 10px;
`
class FileUploader extends Component {
  constructor(props) {
    super(props)
    this.state = {
      docUploadText: 'Drag and drop a file or click to upload a pdf',
      file: '',
      hovering: false,
      dragCounter: 0
    }
  }

  onDocUploadHover = () => {
    this.setState({ docUploadText: 'Click to upload a document', hovering: true })
  }

  onDocUploadLeave = () => {
    const { file } = this.state
    if (file !== '') {
      this.setState({ docUploadText: file.name, hovering: false })
    } else {
      this.setState({ docUploadText: 'Drag and drop a file or click to upload a pdf', hovering: false })
    }
  }
  onDragLeave = () => {
    const { file, dragCounter } = this.state
    if (dragCounter === 1) {
      this.setState({ docUploadText: 'Drag and drop a file or click to upload a pdf', hovering: false })
    }
    if (dragCounter !== 0) {
      this.setState({ dragCounter: dragCounter - 1 })
    }
    if (file !== '') {
      this.setState({docUploadText: file.name})
    }
  }
  onDragEnter = () => {
    const { dragCounter } = this.state
    if (dragCounter === 0) {
      this.setState({ docUploadText: 'Drop to upload a document', hovering: true })
    }
    this.setState({ dragCounter: dragCounter + 1})
  }
  onDragOver = (e) => {
    e.dataTransfer.dropEffect = 'copy'
  }
  onDrop = (acceptedFiles) => {
    this.setState({docUploadText: 'Drag and drop a file or click to upload a pdf'})
    let file = acceptedFiles.dataTransfer ? acceptedFiles.dataTransfer.files : acceptedFiles
    if (file.length > 0) {
      file = file[0]
    }
    this.setState({file}, () => {
      const { file } = this.state
      if (file !== '') {
        this.setState({docUploadText: file.name})
      }
    })
    this.props.uploadDocument(file)
  }

  renderFileUploader = () => {
    const { docUploadText, file, hovering} = this.state
    return (
      <Flex>
        <DocLabel
          onMouseEnter={this.onDocUploadHover}
          onMouseLeave={this.onDocUploadLeave}
          onDragEnter={this.onDragEnter}
          onDragLeave={this.onDragLeave}
          onDragOver={this.onDragOver}
          onDrop={this.onDrop}
          className="esign-label"
          htmlFor="esign-input"
          id="file_uploader_label"
        >
          <DocDrop  hovering={hovering}>
            <Icon className={`fa ${file === '' || hovering ?  'fa-upload' : 'fa-file-text'}`} color="inherit"/>
            {docUploadText}
          </DocDrop>
        </DocLabel>
        <DocInput
          id="esign-input"
          type="file"
          accept="application/pdf"
          onChange={(e) => this.onDrop(e.target.files[0])}
          ref={input => this.fileInput = input}
        />
      </Flex>
    )
  }

  render() {
    return (
      <Fragment>
        {this.renderFileUploader()}
      </Fragment>
    )

  }
}

export default FileUploader
